// extracted by mini-css-extract-plugin
export default {"AccordionRevisionQuestionItem":"AccordionRevisionQuestionItem_AccordionRevisionQuestionItem__Iv8eN","Title":"AccordionRevisionQuestionItem_Title__+VSh7"};